/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Supports_4k_AssetsInputs */

const en_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supports 4K Assets`)
};

const es_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporta activos en 4K`)
};

const fr_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prend en charge les ressources 4K`)
};

const de_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützt 4K-Assets`)
};

const ja_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4Kアセットをサポート`)
};

const zh_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持 4K 级素材`)
};

const ar_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يدعم الأصول بدقة 4K`)
};

const id_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendukung Aset 4K`)
};

const it_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporta Risorse 4K`)
};

const ru_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержка 4K ресурсов`)
};

const pt_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporta Ativos 4K`)
};

const ko_supports_4k_assets = /** @type {(inputs: Supports_4k_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4K 에셋 지원`)
};

/**
* | output |
* | --- |
* | "Supports 4K Assets" |
*
* @param {Supports_4k_AssetsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const supports_4k_assets = /** @type {((inputs?: Supports_4k_AssetsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supports_4k_AssetsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_supports_4k_assets(inputs)
	if (locale === "es") return es_supports_4k_assets(inputs)
	if (locale === "fr") return fr_supports_4k_assets(inputs)
	if (locale === "de") return de_supports_4k_assets(inputs)
	if (locale === "ja") return ja_supports_4k_assets(inputs)
	if (locale === "zh") return zh_supports_4k_assets(inputs)
	if (locale === "ar") return ar_supports_4k_assets(inputs)
	if (locale === "id") return id_supports_4k_assets(inputs)
	if (locale === "it") return it_supports_4k_assets(inputs)
	if (locale === "ru") return ru_supports_4k_assets(inputs)
	if (locale === "pt") return pt_supports_4k_assets(inputs)
	return ko_supports_4k_assets(inputs)
});